import React from 'react';

const IconCaution = props => (
  <svg viewBox="0 0 20 20" {...props}>
    <title>Caution Icon</title>
    <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Caution-Icon" transform="translate(-1.000000, -2.000000)" fill={Styles.color.white}>
        <path
          d="M11.8316943,2.00315065 L12,2 L12.0008171,2.01232643 C13.3990935,2.11328377 14.6634745,2.82953541 15.4698431,3.98160698 L15.607323,4.18940128 L22.2971964,14.8973659 C22.7570214,15.633331 23,16.482854 23,17.3539823 C23,19.8446968 21.0275439,21.8838458 18.5607196,21.99521 L18.3481013,22 L5.51171875,22 C3.02389524,22 1,19.9158601 1,17.3539823 C1,16.579646 1.18619792,15.8223806 1.54079325,15.1467673 L1.68162536,14.8973659 L8.16990661,4.18940128 C8.93908842,2.91990011 10.2237789,2.12419542 11.6543068,2.01334646 L11.6582278,2 C11.7162375,2 11.7740671,2.00105431 11.8316943,2.00315065 Z M13,16 L11,16 L11,18 L13,18 L13,16 Z M13,8 L11,8 L11,14 L13,14 L13,8 Z"
          id="Combined-Shape"
        ></path>
      </g>
    </g>
  </svg>
);

export default IconCaution;
